import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotFoundComponent } from '@app/not-found/not-found.component';
import { LayoutComponent } from '@app/auth/layout/layout.component';
import { ResetpasswordComponent } from './auth/resetpassword/resetpassword.component';
import { StoreAdminAuthGuard } from './core/guards/store-admin.guard';
import { ConfirmEmailComponent } from './auth/confirm-email/confirm-email.component';
import { SuperAdminAuthGuard } from './core/guards/super-admin.guard';
import { PrivacyPolicyComponent } from '@app/auth/privacy-policy/privacy-policy.component';
import { StoreNotOnlineComponent } from './shared/components/store-not-online/store-not-online.component';
import { OpenAPIComponent } from '@app/feature/public/open-api/open-api.component';
import { TShirtComponent } from './auth/tshirt/tshirt.component';
import { HoodiesComponent } from './auth/hoodies/hoodies.component';
import { AboutUsLandingComponent } from './auth/about-us-landing/about-us-landing.component';
import { TermsOfUseComponent } from './feature/super-admin/components/terms-of-use/terms-of-use.component';
import { StoreTermsAndConditionComponent } from './feature/end-user/components/store-terms-and-condition/store-terms-and-condition.component';
import { ContactUsComponent } from './auth/contact-us/contact-us.component';
import { HowItWorksComponent } from './auth/how-it-works/how-it-works.component';
import { TermsConditionComponent } from './auth/terms-condition/terms-condition.component';
import { MasterProductListingComponent } from '@app/shared/components/master-product/product-listing/master-product-listing.component';
import { MasterProductDetailComponent } from './shared/components/master-product/product-detail/master-product-detail.component';
import { StoreOfflineW9SComponent } from './shared/components/store-offline-W9S/store-offline-W9S.component';
import { AcceptInvitationComponent } from './auth/accept-invitation/accept-invitation.component';

const routes: Routes = [
  { path: '', component: LayoutComponent },
  { path: 'RecoverPassword', component: LayoutComponent },  
  { path: 'open-api', component: OpenAPIComponent},
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'terms-of-use', component: TermsConditionComponent },
  { path: 'resetpassword', component: ResetpasswordComponent },
  { path: 'masterproducts', component: MasterProductListingComponent },
  { path: 'masterproduct/detail/:id', component: MasterProductDetailComponent},
  { path: 'confirmemail', component: ConfirmEmailComponent },
  { path: 'accept-invitation', component: AcceptInvitationComponent },
  { path: 'why-us', component: TShirtComponent },
  { path: 'features', component: HoodiesComponent },
  { path: 'about-us', component: AboutUsLandingComponent },
  { path: 'contact-us', component: ContactUsComponent },
  { path: 'how-it-works', component: HowItWorksComponent },
  {
    path: 'store',
    loadChildren: () =>
      import('@app/feature/store-admin/store-admin.module').then(
        (m) => m.StoreAdminModule
      ),
    canActivate: [StoreAdminAuthGuard],
  },
  {
    path: 'superadmin',
    loadChildren: () =>
      import('@app/feature/super-admin/super-admin.module').then(
        (m) => m.SuperAdminModule
      ),
    canActivate: [SuperAdminAuthGuard],
  },
  {
    path: 'public',
    loadChildren: () =>
      import('@app/feature/public/public.module').then(
        (m) => m.PublicModule
      )
  },
  { path: 'orders-details/:orderid', redirectTo: 'public/orders-details/:orderid' },
  { path: '404NotFound', component: NotFoundComponent },
  { path: '404storenotonline', component: StoreNotOnlineComponent },
  { path: 'storeofflineW9S', component: StoreOfflineW9SComponent },
  //Avoid any route name, it may consider it as a store name so place evry individual route above to this
  {
    path: ':storename',
    loadChildren: () =>
      import('@app/feature/end-user/end-user.module').then(
        (m) => m.EndUserModule
      )
  },
  { path: '**', component: NotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
